// extracted by mini-css-extract-plugin
export default {"link":"wN-z","disabled":"xN-z"};